export function esc_title( string ) {
	string = string.toLowerCase().replace( /[áàâå]/g, 'a' )
		.replace( /[ø]/g, 'o' )
		.replace( /[úùû]/g, 'u' )
		.replace( /[äæ]/g, 'ae' )
		.replace( /[ö]/g, 'oe' )
		.replace( /[ü]/g, 'ue' )
		.replace( /[ß]/g, 'ss' )
		.replace( /[éèë]/g, 'e' )
		.replace( /[í]/g, 'i' );
	return string.replace( /[^0-9a-z]/gi, '' );
}

export function hasAncestorOfType( element, type, includeElement ) {
	let hasAncestor = false;
	traverseElementTreeUp( element, ( e ) => {
		if ( e.tagName.toLowerCase() === type ) {
			hasAncestor = true;
			return true;
		}
	}, true );
	return hasAncestor;
}

export function traverseElementTreeUp( element, callback, includeElement ) {
	if ( element ) {
		if ( !includeElement ) {
			element = element.parentElement;
		}
		while ( element ) {
			if ( callback( element ) === false ) {
				break;
			}
			element = element.parentElement;
		}
	}
}